import {axios} from '@/utils/request'

export function getRiskStatistics(parameter = {}) {
  return axios({
    url: '/risk/riskStatistics',
    method: 'post',
    data: parameter
  })
}

export function dailyDecisionStatistics(parameter = {}) {
  return axios({
    url: '/risk/dailyDecisionStatistics',
    method: 'post',
    data: parameter
  })
}

export function getRiskStatisticsById(parameter = {}) {
  return axios({
    url: '/risk/riskStatisticsById',
    method: 'post',
    data: parameter
  })
}

export function riskStrategyList({name, intro, pageNum, pageSize} = {}) {
  return axios({
    url: '/risk/riskStrategyList',
    method: 'post',
    data: {name, intro, pageNum, pageSize}
  })
}

//Query rules: fuzzy query by rule code and description
export function riskFeaturesList({name, intro, pageNum, pageSize} = {}) {
  return axios({
    url: '/risk/riskFeaturesList',
    method: 'post',
    data: {name, intro, pageNum, pageSize}
  })
}

//Modify rule default value
export function updateRiskFeature({id, defaultValue} = {}) {
  return axios({
    url: '/risk/updateRiskFeature',
    method: 'post',
    data: {id, defaultValue}
  })
}

//Rule usage status
export function riskFeaturesUsed({featuresId} = {}) {
  return axios({
    url: '/risk/riskFeaturesUsed',
    method: 'post',
    data: {featuresId}
  })
}

//Batch enable/disable decision sets based on rules
export function banRiskFeatures({featureId, type, idList} = {}) {
  return axios({
    url: '/risk/banRiskFeatures',
    method: 'post',
    data: {featureId, type, idList}
  })
}

//Strategy decision set query: no pagination, frontend filtering
export function riskStrategyFeatures({strategyId} = {}) {
  return axios({
    url: '/risk/riskStrategyFeatures',
    method: 'post',
    data: {strategyId}
  })
}

//Edit decision
export function editRiskRule({id, newRule} = {}) {
  return axios({
    url: '/risk/editRiskRule',
    method: 'post',
    data: {id, newRule}
  })
}

//Batch add decisions
export function addRiskRule({strategyId, idList = []} = {}) {
  return axios({
    url: '/risk/addRiskRule',
    method: 'post',
    data: {strategyId, idList}
  })
}

//Publish decision set
export function releaseRiskRule({strategyId} = {}) {
  return axios({
    url: '/risk/releaseRiskRule',
    method: 'post',
    data: {strategyId}
  })
}

//Delete decision
export function deleteRiskRule({strategyId, idList = []} = {}) {
  return axios({
    url: '/risk/deleteRiskRule',
    method: 'post',
    data: {strategyId, idList}
  })
}

//Edit decisions: decision order, intersection markers
export function editRiskRuleAndGroup(data) {
  return axios({
    url: '/risk/editRiskRuleAndGroup',
    method: 'post',
    data
  })
}

//Create strategy set
export function addRiskStrategy({name, intro} = {}) {
  return axios({
    url: '/risk/addRiskStrategy',
    method: 'post',
    data: {name, intro}
  })
}

//Copy strategy set
export function copyRiskStrategy({id, name, intro} = {}) {
  return axios({
    url: '/risk/copyRiskStrategy',
    method: 'post',
    data: {id, name, intro}
  })
}